import type { Chapter } from "@repo/app-types/entities/course";
import type { FC, ReactNode } from "react";
import { TreeItem } from "react-aria-components";
import { treeItem } from "../../components/tree/treeStyles.js";
import { serializeTreeItemKey } from "../projects/projectSettings/training/courseTreeHelpers.js";

export interface ChapterTreeItemProps {
  index: number;
  chapter: Chapter;
  isDisabled?: boolean;
  onAction?: () => void;
  className?: string;
  children?: ReactNode;
}

/** Renders a chapter tree item in the course tree UI. */
export const ChapterTreeItem: FC<ChapterTreeItemProps> = ({
  index,
  chapter,
  isDisabled,
  onAction,
  className,
  children,
}) => {
  const treeItemId = serializeTreeItemKey({ type: "chapter", id: chapter.id });

  return (
    <TreeItem
      id={treeItemId}
      textValue={chapter.topic || `Chapter ${index + 1}`}
      isDisabled={isDisabled}
      onAction={onAction}
      className={treeItem({
        className,
        // Every chapter forms a new visual group, so it's always the first and last item at this level. (The lessons are items at a deeper level.)
        isLastItemAtLevel: true,
      })}
    >
      {children}
    </TreeItem>
  );
};
